import type { FaireProductEntity } from "../../entity_types/product";

export const p_5chzt7w287: FaireProductEntity = {
  token: "p_5chzt7w287",
  type: "product",
  name: "Lila Bead Necklace",
  brandToken: "b_6ovopeuyoa",
  brandName: "Namaste Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/07958822405c3add3baf0202a736a7256139cf19b6bafcaae22d0227e5738406.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69f2cd34afe1911df270163843edc0b4f74359ea2c32a26b3654025da8bd13ea.jpeg",
  ],
  priceDollars: 25.5,
  description:
    "A necklace that represents you if you are anything but subtle! Made up of assorted natural stones, this handmade necklace will be your new favourite.\n\n• Hypoallergenic\n• Nickel and Lead Free\n• Anti Tarnish\n• Water Resistant\n\nHandmade in Canada\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥/𝐒𝐢𝐳𝐞\nMaterial: 316L recycled stainless steel with 18K PVD gold plating (10 times thicker than regular gold plating)\n\nChain Length: 15.7 inches plus a 2-inch extension\n\nThickness: 2mm\n\nCustom ‘Namaste’ Tag",
  tags: [],
  msrpDollars: 46.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:28.950Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
